import React from 'react';
import { createNavigatorFactory, StackRouter, useNavigationBuilder, } from '@react-navigation/native';
import { NativeStackView } from '@react-navigation/native-stack';
import { useColorMode, useToken } from 'native-base';
const NativeNavigator = ({ children, initialRouteName, screenOptions, ...rest }) => {
    const { colorMode } = useColorMode();
    // Pull header bar colors from theme
    const [bgColor, textColor] = useToken('colors', 
    // TODO: Replace with correct figma token values
    ['<backgroundColor>', '<textTintColor>'], colorMode === 'dark' ? ['#111111', '#FFF'] : ['#F3F4F6', '#030303']);
    const defaultOptions = {
        headerBackButtonMenuEnabled: false,
        headerBackTitleVisible: false,
        headerStyle: {
            backgroundColor: bgColor,
        },
        headerTintColor: textColor,
        headerTitleAlign: 'center',
    };
    let newOptions;
    // Handle extending screenOptions with defaults when either a function or object
    if (typeof screenOptions === 'function') {
        newOptions = (props) => {
            const resolvedOptions = screenOptions(props);
            return Object.assign({}, defaultOptions, resolvedOptions);
        };
    }
    else {
        newOptions = Object.assign({}, defaultOptions, screenOptions);
    }
    const { state, descriptors, navigation } = useNavigationBuilder(StackRouter, {
        initialRouteName,
        children,
        screenOptions: newOptions,
    });
    return (
    // @ts-ignore This is a temporary fix due to a TS issue in the Polaris Web. As known, this component will be removed soon.
    React.createElement(NativeStackView, { ...rest, state: state, navigation: navigation, descriptors: descriptors }));
};
export const createNativeStackNavigator = createNavigatorFactory(NativeNavigator);
